import { Box } from '@mui/material'
import PropTypes from 'prop-types'

export default function ContentContainer({ children }) {
  return (
    <Box
      flex={2}
      p={1}
      m={1}
      display="flex"
      flexDirection="column"
      flexWrap="wrap"
      overflow="auto"
      bgcolor="white"
      sx={{
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Add box shadow here
        borderRadius: 2,
        '&::-webkit-scrollbar': {
          width: '8px',
          height: '8px'
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1'
          // borderRadius: '16px'
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '16px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#555'
        },
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: '#888 #f1f1f1'
        }
      }}
    >
      {children}
    </Box>
  )
}

ContentContainer.propTypes = {
  children: PropTypes.node.isRequired
}
